/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { React, useMemo } from 'react';
import { shape, arrayOf, string } from 'prop-types';
import { ErrorCodes } from '../../services/data/enums';
import { isV2LoginViewMode } from '../../services/utils/supports';
import { trackEvent } from '../../services/tracks';

export const InputError = ({
  errors,
  viewMode,
  viewName,
  completeRegistrationTrack,
}) => {
  const userIncompleteRegistration = useMemo(
    () => errors.find((error) => error.cause === ErrorCodes.USER_INCOMPLETE_REGISTRATION),
    [errors],
  );

  const handleIncompleteRegistration = () => {
    completeRegistrationTrack.event_data.user = {
      user_id: userIncompleteRegistration.hints.user_id,
    };
    trackEvent(completeRegistrationTrack);
    window.location.assign(userIncompleteRegistration.actionUrl);
  };

  return (
    <div className="input-error" role="alert">
      {errors.map(e => (
        <div key={e.cause} className="ui-form__message" id={`${viewName}-message`}>
          {(userIncompleteRegistration && isV2LoginViewMode(viewMode))
            ? (
              <div
                onClick={handleIncompleteRegistration}
                className="ui-form__message--text"
                dangerouslySetInnerHTML={{ __html: e.text }} // eslint-disable-line react/no-danger
              />
            )
            : e.text}
          {e.cause === ErrorCodes.INVALID_USER_SITE
            ? <a href={e.hints.link}>{e.hints.brand}</a>
            : null}
        </div>
      ))}
    </div>
  );
};

InputError.propTypes = {
  errors: arrayOf(shape({
    cause: string.isRequired,
    text: string.isRequired,
    hints: shape({
      user_id: string,
      link: string,
      brand: string,
    }),
    actionUrl: string,
  })).isRequired,
  viewMode: string,
  viewName: string,
  completeRegistrationTrack: shape({
    application: shape({
      business: string,
      site_id: string,
    }).isRequired,
    event_data: shape({
      tracking_id: string,
      source: string,
      challenge: string,
      user: shape({
        user_id: string,
      }),
    }).isRequired,
    path: string.isRequired,
  }),
};
